module.exports = __webpack_public_path__ + "img/out-projects.f5049f6a.png";